
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QMonthGrid extends Serenity.EntityGrid<QMonthRow, any> {
        protected getColumnsKey() { return QMonthColumns.columnsKey; }
        protected getDialogType() { return QMonthDialog; }
        protected getIdProperty() { return QMonthRow.idProperty; }
        protected getInsertPermission() { return QMonthRow.insertPermission; }
        protected getLocalTextPrefix() { return QMonthRow.localTextPrefix; }
        protected getService() { return QMonthService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}